import { render, staticRenderFns } from "./businessGoodsInit.vue?vue&type=template&id=8eef1c6c&scoped=true"
import script from "./businessGoodsInit.vue?vue&type=script&lang=js"
export * from "./businessGoodsInit.vue?vue&type=script&lang=js"
import style0 from "./businessGoodsInit.vue?vue&type=style&index=0&id=8eef1c6c&prod&scoped=true&lang=css"
import style1 from "./businessGoodsInit.vue?vue&type=style&index=1&id=8eef1c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eef1c6c",
  null
  
)

export default component.exports